<template>
  <div class="flex items-center gap-2 mt-2 flex-wrap">
    <div
      class="button-ghost px-4 py-[7px] flex items-center gap-1"
      :class="{ disabled: !canReply }"
      @click="onReplyClick"
    >
      <span class="material-symbols-outlined text-[24px]/[24px]"> reply </span>
      <span class="leading-[24px]">
        {{ $t('CONVERSATION.REPLYBOX.REPLY') }}
      </span>
    </div>
    <div
      class="button-ghost px-4 py-[7px] flex items-center gap-1"
      :class="{ disabled: !canReply }"
      @click="onReplyAllClick"
    >
      <span class="material-symbols-outlined text-[24px]/[24px]">
        reply_all
      </span>
      <span class="leading-[24px]">
        {{ $t('CONVERSATION.REPLYBOX.REPLY_ALL') }}
      </span>
    </div>
    <div
      class="button-ghost px-4 py-[7px] flex items-center gap-1"
      :class="{ disabled: !canForward }"
      @click="onForwardClick"
    >
      <span
        class="material-symbols-outlined text-[24px]/[24px] scale-x-[-100%]"
      >
        reply
      </span>
      <span class="leading-[24px]">
        {{ $t('CONVERSATION.REPLYBOX.FORWARD') }}
      </span>
    </div>
    <div
      class="button-ghost px-4 py-[7px] flex items-center gap-1"
      :class="{ disabled: !canAddPrivateNote }"
      @click="onPrivateNoteClick"
    >
      <span class="material-symbols-outlined text-[24px]/[24px]"> draft </span>
      <span class="leading-[24px]">
        {{ $t('CONVERSATION.REPLYBOX.PRIVATE_NOTE') }}
      </span>
    </div>
  </div>
</template>

<script>
import hasPermissionMixin from 'dashboard/mixins/hasPermission';

export default {
  mixins: [hasPermissionMixin],
  computed: {
    canReply() {
      return this.hasInboxPermission('Inbox reply');
    },
    canForward() {
      return this.hasInboxPermission('Inbox new message');
    },
    canAddPrivateNote() {
      return this.hasInboxPermission('Inbox private notes');
    },
  },
  methods: {
    onReplyClick() {
      if (this.canReply) {
        this.$emit('reply');
      }
    },
    onReplyAllClick() {
      if (this.canReply) {
        this.$emit('reply-all');
      }
    },
    onForwardClick() {
      if (this.canForward) {
        this.$emit('forward');
      }
    },
    onPrivateNoteClick() {
      if (this.canAddPrivateNote) {
        this.$emit('note');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.button-ghost {
  box-shadow: 0 1px 8px 0 rgba(221, 221, 221, 0.25);

  .material-symbols-outlined {
    @apply text-gray-500;
  }

  &.disabled {
    @apply bg-neutral-50 border border-neutral-200 text-neutral-400 cursor-not-allowed;

    .material-symbols-outlined {
      @apply text-neutral-300;
    }
  }
}
</style>
